// ASSOCHAM navigation structure
import {
  FaLandmark,
  FaChartBar,
  FaHandshake,
  FaBullseye,
  FaBriefcase,
  FaGlobeAsia,
  FaRocket,
  FaLeaf,
   FaGlobe,
} from "react-icons/fa";

export const NAV_DATA = [
{
    label: "About",
    href: "/about-us",
    items: [
      { label: "About Us", href: "/about-us" },
      { label: "Leadership", href: "/about/leadership" },
      { label: "Our Team", href: "/about/our-team" },
      { label: "Past President", href: "/about/past-president" },
      { label: "Notice of ASSOCHAM 105th AGM", href: "https://assocham.org/assets/pdf/assocham_105th_AGM_Notice_2025.pdf", target: "_blank", },
      // { label: "Notice of ASSOCHAM 105th AGM", href: "/about/agm-notice" },
      { label: "Financials", href: "https://assocham.org/assets/pdf/form_MGT_7_ASSOCHAM_2024.pdf" },
    ],
  },
  // {
  //   label: "Initiatives",
  //   href: "#initiatives",
  //   items: [
  //     "Startup Mahakumbh",
  //     "GEM Green Building Certification Program",
  //     "Intellectual Property Facilitation Centre",
  //   ],
  // },
{
  label: "Sectors",
  href: "#sectors",
  type: "nested", // triggers 2-level (sector -> councils) dropdown
  items: [
    {
      label: "Agriculture & Food Processing",
      href: "/agriculture-food-processing",
      councils: [
        { label: "Agri Industries & Farming Practices", href: "/agriculture-food-processing" },
        { label: "Food Processing & Value Addition", href: "/food-processing-value-addition" },
      ],
    },
    {
      label: "Green Mobility and Automotive & Auto Components",
      href: "#green-mobility-and-automotive-auto-components",
      councils: [
        { label: "Auto & Auto Ancillaries", href: "#auto-auto-ancillaries" },
        { label: "Green Mobility", href: "#green-mobility" },
      ],
    },
    {
      label: "MSME",
      href: "#msme",
      councils: [
        { label: "MSME Development Council", href: "#msme-development-council" },
      ],
    },
    {
      label: "Electronic Device & Semiconductor Manufacturing (EDSM)",
      href: "#electronic-device-semiconductor-manufacturing-edsm",
      councils: [
        { label: "Electronics & Components", href: "#electronics-components" },
      ],
    },
    {
      label: "Pharma, Med-tech & Healthcare",
      href: "#pharma-med-tech-healthcare",
      councils: [
        { label: "Pharmaceuticals", href: "#pharmaceuticals" },
        { label: "Med-tech Devices", href: "#med-tech-devices" },
        { label: "Healthcare & Wellness", href: "#healthcare-wellness" },
      ],
    },
    {
      label: "Power & Energy (including Renewable Energy, Hydro/PSP, Thermal & Nuclear)",
      href: "#power-energy-including-renewable-energy-hydro-psp-thermal-nuclear",
      councils: [
        { label: "Hydropower & PSP", href: "#hydropower-psp" },
        { label: "Power Generation", href: "#power-generation" },
        { label: "Power Distribution", href: "#power-distribution" },
        { label: "Power Transmission", href: "#power-transmission" },
        { label: "Renewable Energy", href: "#renewable-energy" },
      ],
    },
    {
      label: "IT/ITeS (including Digital Tech/Fintech)",
      href: "#it-ites-including-digital-tech-fintech",
      councils: [
        { label: "Animation, Visual Effects, Gaming & Comics (AVGC)", href: "#animation-visual-effects-gaming-comics-avgc" },
        { label: "Cyber Security & Cyber Law", href: "#cyber-security-cyber-law" },
        { label: "Data Centre", href: "#data-centre" },
        { label: "Digital Communication", href: "#digital-communication" },
        { label: "IT & ITeS & Digital Commerce", href: "#it-ites-digital-commerce" },
        { label: "Fintech", href: "#fintech" },
      ],
    },
    {
      label: "Banking, Financial Services & Insurance (BFSI)",
      href: "#banking-financial-services-insurance-bfsi",
      councils: [
        { label: "Banking", href: "#banking" },
        { label: "Capital Markets", href: "#capital-markets" },
        { label: "Commodity Markets & Investments", href: "#commodity-markets-investments" },
        { label: "Corporate Bond Market", href: "#corporate-bond-market" },
        { label: "Insurance", href: "#insurance" },
        { label: "NBFCs & Green Financing", href: "#nbfcs-green-financing" },
        { label: "Stressed Assets", href: "#stressed-assets" },
        { label: "CFOs", href: "#cfos" },
      ],
    },
    {
      label: "Education & Skilling",
      href: "#education-skilling",
      councils: [
        { label: "National Council on Education", href: "#national-council-on-education" },
      ],
    },
    {
      label: "Taxation - Direct / Indirect",
      href: "#taxation-direct-indirect",
      councils: [
        { label: "Direct Taxes", href: "#direct-taxes" },
        { label: "Indirect Taxes", href: "#indirect-taxes" },
      ],
    },
    {
      label: "Logistics & Warehousing",
      href: "#logistics-warehousing",
      councils: [
        { label: "Logistics and Warehousing", href: "#logistics-and-warehousing" },
      ],
    },
    {
      label: "Legal & Corporate Affairs",
      href: "#legal-corporate-affairs",
      councils: [
        { label: "Corporate Affairs, Company Law, & Corporate Governance", href: "#corporate-affairs-company-law-corporate-governance" },
        { label: "Intellectual Property Rights", href: "#intellectual-property-rights" },
        { label: "Legal Affairs & Regulatory Reforms", href: "#legal-affairs-regulatory-reforms" },
      ],
    },
    {
      label: "Infrastructure (Port, Shipping and Waterways, Task Force)",
      href: "#infrastructure-port-shipping-and-waterways-task-force",
      councils: [
        { label: "Civil Aviation", href: "#civil-aviation" },
        { label: "Highway & Tunnel Infrastructure", href: "#highway-tunnel-infrastructure" },
        { label: "Railways Council", href: "#railways-council" },
      ],
    },
    {
      label: "Sustainability & Environment (including Water / GEM)",
      href: "#sustainability-environment-including-water-gem",
      councils: [
        { label: "Sustainability & Environment", href: "#sustainability-environment" },
        { label: "Water", href: "#water" },
      ],
    },
    {
      label: "Tourism (including Religious & Adventure Tourism)",
      href: "#tourism-including-religious-adventure-tourism",
      councils: [
        { label: "Travel, Tourism and Hospitality", href: "#travel-tourism-and-hospitality" },
        { label: "Branding & Marketing", href: "#branding-marketing" },
      ],
    },
    {
      label: "Real Estate & Urban Development",
      href: "#real-estate-urban-development",
      councils: [
        { label: "Real Estate, Housing and Urban Development", href: "#real-estate-housing-and-urban-development" },
        { label: "Public Procurement", href: "#public-procurement" },
        { label: "SEZ and Industrial Zones", href: "#sez-and-industrial-zones" },
      ],
    },
    {
      label: "Manufacturing",
      href: "#manufacturing",
      councils: [
        { label: "Manufacturing & Capital Goods", href: "#manufacturing-capital-goods" },
        { label: "Textile & Technical Textile", href: "#textile-technical-textile" },
        { label: "Toy Council", href: "#toy-council" },
        { label: "Chemical & Petrochemicals", href: "#chemical-petrochemicals" },
        { label: "EODB Council", href: "#eodb-council" },
        { label: "HR & IR Policies and Reforms", href: "#hr-ir-policies-and-reforms" },
        { label: "Defence & Aerospace", href: "#defence-aerospace" },
      ],
    },
    {
      label: "Mines & Minerals (including Rare Earth, Iron & Steel)",
      href: "#mines-minerals-including-rare-earth-iron-steel",
      councils: [
        { label: "Mines & Minerals", href: "#mines-minerals" },
        { label: "Iron & Steel", href: "#iron-steel" },
      ],
    },
    {
      label: "International Affairs",
      href: "#international-affairs",
      councils: [
        { label: "Exports & Trade", href: "#exports-trade" },
        { label: "Business through Diplomacy", href: "#business-through-diplomacy" },
        { label: "Africa Business Council", href: "#africa-business-council" },
        { label: "BIMSTEC", href: "#bimstec" },
        { label: "Eurasia", href: "#eurasia" },
      ],
    },
    {
      label: "Startups",
      href: "#startups",
      councils: [
        { label: "Startup", href: "#startup" },
      ],
    },
  ],
},

  {
    label: "States",
    href: "#states",
    columns: true,
    items: [
      "Andhra Pradesh",
      "Bihar",
      "Central Region",
      "Chandigarh",
      "Chhattisgarh",
      "Delhi",
      "Eastern Region",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jammu & Kashmir",
      "Karnataka",
      "Kerala",
      "Ladakh",
      "Madhya Pradesh",
      "Maharashtra",
      "North East",
      "Northern Region",
      "Odisha",
      "Pondicherry",
      "Punjab",
      "Rajasthan",
      "Tamil Nadu",
      "Telangana",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal",
    ],
  },
  { label: "International", href: "#international" },
  // { label: "Knowledge",
  //    href: "#knowledge", 
  //    items: [
  //     "Reports",
  //     "ASSOCHAM Voice",
  //     "Global Research Centre",
  //   ],
  //   },

      {
    label: "Global Research",
    href: "/global-research",
    items: [
      { label: "Economic Growth & Development", href: "/global-research/economic-growth" },
      { label: "Ease of Doing Business", href: "global-research/eodb" },
      { label: "Trade & Investment Promotion Services", href: "global-research/tips" },
      { label: "Publications", href: "/global-research/publications" },
    ],
  },
  {
    label: "Knowledge",
    // href: "/overview-knowledge-center",
    items: [
      { label: "Reports", href: "/knowledge/reports" },
      { label: "ASSOCHAM Voice", href: "/knowledge/assocham-voice" },
      { label: "Bulletins", href: "/knowledge/bulletins" },
    ],
  },
  { label: "Events", href: "/events" },
  { label: "Membership", href: "/membership" },
  { label: "AFCSR", href: "/afcsr" },
  {
    label: "Newsroom",
    
    items: [
      { label: "Press Release", href: "/newsroom/press-release" },
      { label: "Press Coverage", href: "/newsroom/press-coverage" },
      { label: "Image Library", href: "/newsroom/image-library" },
    ],
  },


];

export const TICKER_ITEMS = [
  "GOVERNMENT MEASURES TO MITIGATE IMPACT OF WEST ASIA CONFLICT ON INDIA",
  "D&B ASSOCHAM Report",
  "Industry Standards Note on Regulation 30 of the LODR Regulations",
  "SEBI Circular - Industry Standards on RPTs",
  "ASSOCHAM Compendium 2024",
  "Startup Mahakumbh Podcasts",
  "FAQs on Applicability of the Industry Standards on Related Party Transaction",
  "India–UAE CEPA Review: ASSOCHAM Submission",
  "National Logistics Policy — Industry Recommendations",
];

export const KNOWLEDGE_REPORTS = [
  {
    title: "India @ 2047: Roadmap to a $30 Trillion Economy",
    category: "Economy",
    date: "Nov 2025",
    img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80",
  },
  {
    title: "Green Hydrogen & Derivatives — Sector Outlook",
    category: "Energy",
    date: "Oct 2025",
    img: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=800&q=80",
  },
  {
    title: "AI Task Force: Responsible AI for Indian Enterprise",
    category: "Technology",
    date: "Oct 2025",
    img: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
  },
  {
    title: "MSME Credit Flow & Green Financing 2025",
    category: "Finance",
    date: "Sep 2025",
    img: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800&q=80",
  },
  {
    title: "Digital Health — Building Bharat's Care Stack",
    category: "Healthcare",
    date: "Sep 2025",
    img: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80",
  },
  {
    title: "Travel, Tourism & Hospitality — Inbound Trends",
    category: "Tourism",
    date: "Aug 2025",
    img: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&q=80",
  },
];

export const NEWSLETTERS = [
  { title: "ASSOCHAM Weekly Bulletin — Vol. 48", date: "Nov 28, 2025", pages: 24 },
  { title: "Policy Pulse — Direct & Indirect Taxes", date: "Nov 21, 2025", pages: 16 },
  { title: "Sector Spotlight — Renewable Energy", date: "Nov 14, 2025", pages: 20 },
  { title: "Regional Digest — North & East India", date: "Nov 07, 2025", pages: 18 },
];

export const PRESS_RELEASES = [
  {
    title: "ASSOCHAM urges faster rollout of PLI 2.0 for electronics & semiconductors",
    date: "Dec 02, 2025",
    tag: "Press Release",
  },
  {
    title: "Union Budget 2026 — ASSOCHAM Pre-Budget Memorandum submitted to MoF",
    date: "Nov 29, 2025",
    tag: "Press Release",
  },
  {
    title: "Startup Mahakumbh 2026 registrations open; 15,000+ startups expected",
    date: "Nov 25, 2025",
    tag: "Press Release",
  },
  {
    title: "Green Building certifications cross 2,500 projects under GEM programme",
    date: "Nov 20, 2025",
    tag: "Press Release",
  },
];

export const PRESS_COVERAGE = [
  {
    title: "ASSOCHAM sees 7.2% GDP growth for FY26 on strong capex cycle",
    source: "The Economic Times",
    date: "Dec 01, 2025",
  },
  {
    title: "Industry body pushes for uniform GST on insurance premium",
    source: "Business Standard",
    date: "Nov 28, 2025",
  },
  {
    title: "ASSOCHAM partners with MeitY on AI skilling for 1 lakh youth",
    source: "Mint",
    date: "Nov 26, 2025",
  },
  {
    title: "Port & Shipping reforms key to $2T export target: ASSOCHAM",
    source: "The Hindu BusinessLine",
    date: "Nov 22, 2025",
  },
];

export const EVENTS = [
  {
    title: "105th ASSOCHAM Annual General Meeting",
    date: "Dec 18, 2025",
    location: "New Delhi",
    category: "Flagship",
    img: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=900&q=80",
  },
  {
    title: "Startup Mahakumbh 2026",
    date: "Feb 12–14, 2026",
    location: "Bharat Mandapam, Delhi",
    category: "Initiative",
    img: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=900&q=80",
  },
  {
    title: "National Summit on Green Hydrogen",
    date: "Jan 22, 2026",
    location: "Mumbai",
    category: "Energy",
    img: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=900&q=80",
  },
  {
    title: "Global AI Conclave 2026",
    date: "Mar 05, 2026",
    location: "Bengaluru",
    category: "Technology",
    img: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=900&q=80",
  },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_208d7d52-3a9b-4a95-93a0-6e4a9b862f74/artifacts/7jp1o2sh_assocham-logo-new%20%281%29.jpg";



//   export const pillars = [
//   { icon: FaLandmark, label: "Policy Advocacy" },
//   { icon: FaChartBar, label: "Research & Reports" },
//   { icon: FaHandshake, label: "Industry Networking" },
//   { icon: FaBullseye, label: "Capacity Building" },
//   { icon: FaBriefcase, label: "Business Opportunities" },
//   { icon: FaGlobeAsia, label: "Global Partnerships" },
//   { icon: FaRocket, label: "Start-up Support" },
//   { icon: FaLeaf, label: "Sustainability & ESG" },
// ];

export const pillars = [
  { icon: FaGlobe, label: "Global Outreach" },
  { icon: FaChartBar, label: "Business Development Services" },
  { icon: FaHandshake, label: "Knowledge Work" },
  { icon: FaBullseye, label: "Policy Advocacy" },
  { icon: FaBriefcase, label: "Sustainability Services" },
  { icon: FaLandmark, label: "CSR Services" },
];




export const knowledgeReports = [
  { title: "Sustainable Financial Ecosystem For Viksit Bharat March 2026", date: "May 2024", img: "https://assocham.org/assets/images/1776425322_2.jpg", color: "#1a1a4e" },
 
  { title: "ASSOCHAM ASCELA Report Future Ready Railways", date: "May 2024", img: "https://assocham.org/assets/images/1775723918_Screenshot%202026-04-09%20140531.jpg", color: "#7b1a1a" },

  { title: "NutriBharat@20247", date: "April 2024", img: "https://assocham.org/assets/images/1775281193_NutriBharat@20247.jpg", color: "#1a4e1a" },

  { title: "Integrating the billion market into the $5 Trillion Indian Economy and Global Financial Order", date: "April 2024", img: "https://assocham.org/assets/images/1776771415_Golds%20New%20Horizon.jpg", color: "#c0392b" },
];

export const newsletters = [
  { title: "ASSOCHAM_VOICE_APRIL_2026", issue: "May 2024 | Volume 15, Issue 5", img: "https://www.assocham.org/assets/images/1779087529_ASSOCHAMVOICE_APR-2026.jpg" },
  { title: "E-Bulletin on Banking & Financial Services", issue: "April 2024 | Volume 15, Issue 4", img: "https://www.assocham.org/assets/images/1778560410_Banking%20Financial%20Services%20&%20Insurance%20(BFSI)_April%202026.jpg" },
  { title: "ASSOCHAM_VOICE_JAN_FEB_2026", issue: "March 2024 | Volume 15, Issue 3", img: "https://www.assocham.org/assets/images/1772008248_ASSOCHAMVOICE_JAN-FEB2026.jpg" },
  // { title: "ASSOCHAM Update", issue: "FEB 2024 | Volume 15, Issue 3", img: "https://images.unsplash.com/photo-1635254720645-32746e3279c9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDEzfHx8ZW58MHx8fHx8" },
];

export const global = [
  { title: "ASSOCHAM India Monitor (AIM Weekly)_06th", issue: "May 2024 | Volume 15, Issue 5", img: "https://www.assocham.org/assets/images/1780896035_AIM_V3I1_6.6.26.jpg" },
  { title: "ASSOCHAM India Monitor (AIM Weekly)_30th", issue: "April 2024 | Volume 15, Issue 4", img: "https://www.assocham.org/assets/images/1780130618_AIM%20Weekly_30_05_26.jpg" },
  { title: "ASSOCHAM India Monitor (AIM Weekly) for", issue: "March 2024 | Volume 15, Issue 3", img: "https://www.assocham.org/assets/images/1779685254_ABCD_22_05_2026.jpg" },
  // { title: "ASSOCHAM Update", issue: "FEB 2024 | Volume 15, Issue 3", img: "https://images.unsplash.com/photo-1635254720645-32746e3279c9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDEzfHx8ZW58MHx8fHx8" },
];

export const pressReleases = [
  { date: "24 MAY 2024", text: "ASSOCHAM suggests policy reforms to boost Ease of Doing Business in India" },
  { date: "20 MAY 2024", text: "ASSOCHAM releases report on 'Future of Manufacturing in India'" },
  { date: "16 MAY 2024", text: "ASSOCHAM organizes National Conference on Green Energy Transition" },
];

export const mediaCoverage = [
  { source: "The Economic Times", logo: "/assets/logos/economic-times.png", text: "ASSOCHAM calls for tax rationalization in Union Budget 2024", img: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=250&h=150&fit=crop", color: "#FF6600" },

  { source: "Business Standard", logo: "/assets/logos/business-standard.png", text: "India's growth momentum to continue: ASSOCHAM", img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=250&h=150&fit=crop", color: "#CC0000" },

  { source: "Financial Express", logo: "/assets/logos/financial-express.png", text: "ASSOCHAM recommends policy measures for MSME sector", img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=250&h=150&fit=crop", color: "#003087" },
  
  { source: "Mint", logo: "/assets/logos/mint.png", text: "Strengthening India's Global Trade Competitiveness", img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=250&h=150&fit=crop", color: "#006400" },
];
